export class Margin {
  pLeft: number = 0;
  pTop: number = 0;
  pRight: number = 0;
  pBottom: number = 0;
  pAll: number = 0;
  pVertical: number = 0;
  pHorizontal: number = 0;

  constructor(options: {
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
    all?: number;
    vertical?: number;
    horizontal?: number;
  }) {
    // Store shorthand values (default 0)
    this.pAll = options.all ?? 0;
    this.pVertical = options.vertical ?? this.pAll;
    this.pHorizontal = options.horizontal ?? this.pAll;

    // Apply margins in order: shorthand → axis → explicit override
    this.pTop = options.top ?? this.pVertical;
    this.pBottom = options.bottom ?? this.pVertical;
    this.pLeft = options.left ?? this.pHorizontal;
    this.pRight = options.right ?? this.pHorizontal;
  }

  get left(): number {
    return this.pLeft ?? this.pHorizontal ?? this.pAll ?? 0;
  }

  get right(): number {
    return this.pRight ?? this.pHorizontal ?? this.pAll ?? 0;
  }

  get top(): number {
    return this.pTop ?? this.pVertical ?? this.pAll ?? 0;
  }

  get bottom(): number {
    return this.pBottom ?? this.pVertical ?? this.pAll ?? 0;
  }

  get vertical(): number {
    return this.top + this.bottom;
  }

  get horizontal(): number {
    return this.left + this.right;
  }
}
